import { FilterMatchMode, FilterOperator } from "primereact/api";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";

import AddEventRegister from "../componets/AddEventRegister";
import { eventRegisterService } from "../services/EventRegisterService";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { InputTextarea } from "primereact/inputtextarea";
import TextInput from "../componets/TextInput";
import EventService, { eventService } from "../services/EventService";
import { EventsTree } from "./EventsTree";
import { AppDB } from "../App";
import { APP_TYPE, formatDate } from "../config/Config";
import { BreadCrumb } from "primereact/breadcrumb";
import { permissionLookUp } from "../constants";
import AddSignature from "../componets/AddSignature";
import EditRegister from "../componets/EditRegister";
import ScreenLoader from "../componets/ScreenLoader";
import { reportService } from "../services/ReportService";
import PrintOutAction from "./reports/PrintOutAction";
import { PrintOut } from "./reports/PrintOut";
import DropDown from "../componets/DropDown";
import { lookupsService } from "../services/LookupsService";
import { TreeTable } from "primereact/treetable";
import { delimitationService } from "../services/DelimitationService";
import { changeLang } from "../componets/Language/ChangeLang";
import { Checkbox } from "primereact/checkbox";
import e from "cors";
import registerManagementReportService from "../services/RegisterManagementReportService";
import { confirmDialog } from "primereact/confirmdialog";
import { Divider } from "primereact/divider";


export const EventElectionRegister = () => {
	const { toast, permission } = useContext(AppDB);
	let [voterRegisters, setVoterRegisters] = useState([]);
	let [showAddRegisterForm, setShowAddRegisterForm] = useState(false);
	let [registerType, setRegisterType] = useState(null);
	var raw={
		name: "",
		description: "",
		eventID: null,
		registerTypeID: null,
		isNationalDelimitation: null,
		voterRegisterTypeID: "",
		config: {
			distributeRemainder: true,
			sortField: "Surname",
			sortOrderAscending: true,
			electorsPerPollingStation: 200,
			recreate: true
		}
	}
	let [addRegisterForm, setAddRegisterForm] = useState(raw);

	const [signatureData, setsignatureData] = useState(null);
	const [showCertifyRegisterForm, setShowCertifyRegisterForm] = useState(false);
	const [selectedRegister, setSelectedRegister] = useState(null);
	const [showEditRegister, setshowEditRegister] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [isLoading, setisLoading] = useState(false);
	const [lookups, setLookups] = useState({
		voterRegisterTypes: [],
		registerTypes: []
	});

	useEffect(() => {
		GetAllEvents();

		lookupsService
			.getAll()
			.then((data) => {
				setLookups({
					voterRegisterTypes: data?.voterRegisterTypes,
					registerTypes: data?.registerTypes
				});
			})
			.catch((error) => {
				console.error("Error fetching lookups:", error);
			});
	}, []);
	async function GetAllEventRegisters(payload) {
		setisLoading(true);
		if (!payload) {
			payload = {
				registerTypeID: registerType?.id,
				eventID: selectedeventsPergroup?.eventID,
				eventGroupID: selectedEventgroup?.eventGroupID
			};
		}
		payload.CheckProcessingStatus = true
		await eventRegisterService
			.getAll(payload)
			.then((data) => {
				setVoterRegisters(data);
				setisLoading(false);
			})
			.catch((err) => {
				setisLoading(false);
			});
	}

	async function AddNewRegister(registerForm) {
		try {
			setisLoading(true); 
			const res = await eventRegisterService.create(registerForm);
			if (res?.success) {
				setisLoading(false);
				setShowAddRegisterForm(false);
				GetAllEventRegisters();
				setfetchReportLoader(false);
				setAddRegisterForm({
					...raw,
					registerTypeID: registerType?.id,
				});
			}

			return toast.show({
				severity: res?.success ? "success" : "error",
				summary: "Message",
				detail: res?.message,
				life: 2000
			});
		} catch (e) {
			setfetchReportLoader(false);
			toast.show({
				severity: "error",
				summary: "Error Message",
				detail: "Something went wrong",
				life: 2000
			});
		} finally {
			setisLoading(false);
			setfetchReportLoader(false);
		}
	}

	const handleRegisterClick = (registerData) => {
		setSelectedRegister(registerData);
		setShowCertifyRegisterForm(true);
	};

	var payload = {
		voterRegisterID: selectedRegister?.voterRegisterID,
		eventID: selectedRegister?.eventID,
		voterRegisterTypeID: selectedRegister?.voterRegisterTypeID,
		signature: signatureData
	};
	var [signatureForm, setSignatureForm] = useState({
		BinaryData: "",
		FileExt: "",
		ContentType: ""
	});

	const handleCertify = () => {
		setisLoading(true);
		eventRegisterService
			.certifyRegister(payload, selectedRegister?.voterRegisterID)
			.then((res) => {
				setisLoading(false);
				if (res?.success) {
					setShowCertifyRegisterForm(false);
					GetAllEventRegisters();
					setsignatureData(null);
				}

				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				setisLoading(false);
				console.log(err);
				return toast.show({
					severity: "error",
					summary: "Message",
					detail: "Something went wrong",
					life: 2000
				});
			});
	};
	const handleEditRegister = () => {};
	const [showReport, setshowReport] = useState(false);
	const handleDownloadReport = (data) => {
		setisLoading(true);
		let ReportId = "";
		if (data?.voterRegisterTypeID === 1) {
			ReportId = 21; //Provisiona
		} else if (data?.voterRegisterTypeID === 2) {
			ReportId = 22; //Final
		}

		const payload = {
			mergeFiles: mergeReportFiles,
			demarcationList: [],
			voterRegisterID: data?.voterRegisterID
		};
		registerManagementReportService
			.downloadVoterRegisterRollReport(payload)
			.then((response) => {
				if (response?.success) {
					const byteCharacters = atob(response.data);
					const byteNumbers = new Array(byteCharacters.length);

					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}

					const byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([byteArray], { type: "application/pdf" });

					const fileName = `Register_${crypto.randomUUID()}.pdf`;

					const url = URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					document.body.appendChild(a);
					a.download = fileName;
					a.click();
					a.remove();
					URL.revokeObjectURL(url);
					toast.show({
						severity: "success",
						summary: "",
						detail: "Voter's register Successfully Downloaded.",
						life: 3000
					});
					setisLoading(false);
					
				} else {
					setisLoading(false);
					toast.show({ severity: "error", summary: "Message", detail: response?.message || "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				setisLoading(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};
	const [base64, setBase64] = useState(null);
	const [fetchReportLoader, setfetchReportLoader] = useState(false);
	const delimitationReport = (data) => {
		let filename = "Voters Register";
		setfetchReportLoader(true);
		const payload = {
			mergeFiles: mergeReportFiles,
			demarcationList: data,
			voterRegisterID: voterRegisterType?.voterRegisterID
		};
		registerManagementReportService
			.downloadDelimitationReport(payload)
			.then((response) => {
				if (response?.success) {
					console.log(response);

					registerManagementReportService
						.downloadFile(response?.data)
						.then((blob) => {
							// Create a download link
							const url = URL.createObjectURL(blob);
							const a = document.createElement("a");
							a.href = url;
							document.body.appendChild(a);
							a.click();
							a.remove();
							URL.revokeObjectURL(url);
							toast.show({
								severity: "success",
								summary: "",
								detail: "Voter's register Successfully Downloaded.",
								life: 3000
							});
							setfetchReportLoader(false);
						})
						.catch((error) => {
							setfetchReportLoader(false);
							console.error("Download error:", error);
							toast.show({
								severity: "error",
								summary: "Download Failed",
								detail: error.message,
								life: 3000
							});
						});
				} else {
					setfetchReportLoader(false);
					toast.show({ severity: "error", summary: "Message", detail: response?.message || "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};

	const getReport = (data) => {
		reportService
			.getReport(data)
			.then((response) => {
				setfetchReportLoader(false);
				if (response?.success) {
					setshowReport(true);
					setBase64(response.data);
					toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
				} else {
					toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				console.log(err);
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};

	async function getRegisterReport(requestData) {
		setfetchReportLoader(true);
		await registerManagementReportService
			.viewdownloadDelimitationReport(requestData)
			.then((data) => {
				setfetchReportLoader(false);
				if (data?.success) {
					// const url = `data:application/pdf;base64,${base64}`;
					// window.open(url, "_blank");

					setshowReport(true);
					setBase64(data?.data);
					toast.show({ severity: "success", summary: "", detail: data.message, life: 3000 });
				} else {
					toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				console.log(err);
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	}
	var defaultOptions = [
		{
			name: "Provisional Register",
			reportID: 20,
			delimitation: true,
			showVillage: false,
			isNationalElectionReport: true,
			application_type: false,
			application_status: false,
			elibility_status: false,
			start_date: false,
			end_date: false,
			IncludeSupplimentaryReport: false,
			portal: true,
			eventType: false,
			isProvisional: true
		},
		{
			name: "National Election Final Register",
			reportID: 11,
			delimitation: true,
			showVillage: false,
			isNationalElectionReport: true,
			application_type: false,
			application_status: false,
			elibility_status: false,
			start_date: false,
			end_date: false,
			IncludeSupplimentaryReport: false,
			portal: true,
			eventType: false,
			isFinal: true,
			showVillage: false
		}
	];

	var [options, setOptions] = useState(defaultOptions);
	var [finalEventsRegister, setFinalEventsRegister] = useState([]);
	var [provisionalEventsRegister, setProvisionalEventsRegister] = useState([]);
	useEffect(() => {
		if (APP_TYPE == "PoliticalParty") {
			setOptions(defaultOptions.filter((e) => e.reportID != 11 && e.reportID != 20));
		}

		var provisional = eventService.getEventByRegisterAll({
			RegisterTypeID: 1,
			IsPoliticalPaty: APP_TYPE == "PoliticalParty"
		});

		var finalTest = eventService.getEventByRegisterAll({
			RegisterTypeID: 2,
			IsPoliticalPaty: APP_TYPE == "PoliticalParty"
		});

		Promise.all([provisional, finalTest]).then((response) => {
			var provisional = response[0]?.length || 0;
			var final = response[1]?.length || 0;
			setProvisionalEventsRegister(response[0]);
			setFinalEventsRegister(response[1]);

			var filtered = defaultOptions;
			if (provisional == 0) {
				filtered = filtered.filter((e) => e.reportID != 20);
			}

			if (final == 0) {
				filtered = filtered.filter((e) => e.reportID != 11);
			}

			setOptions(filtered);
		});
	}, [APP_TYPE]);

	// function filterForPortal() {
	// 	if (isPortal == true) {
	// 		return options.filter((e) => e.portal === true);
	// 	}
	// 	return options;
	// }

	var [reportInfo, setReportInfo] = useState({
		eventGroupID: 1,
		delimitationgroup: 1,
		startDate: new Date(),
		endDate: new Date(),
		selectedReport: null,
		delimitationID: null,
		delimitationLevelID: null,
		applicationTypeID: null,
		applicationStatusID: null,
		EligibilityStatus: null,
		IncludeSupplimentaryReport: false,
		EventID: null,
		IsInternal: APP_TYPE != "PoliticalParty",
		showVillage: true
	});

	const [voterRegisterType, setVoterRegisterType] = useState(null);
	const fetchDistrictsForRegister = async (selectedRegisterType) => {
		if (selectedRegisterType?.isNationalDelimitation) {
			getAllDistricts(selectedRegisterType);
		} else {
			GetLocalDistricts(selectedRegisterType);
		}
	};

	const getAllDistricts = (event) => {
		const payload = {
			delimitationLevelID: event?.node?.data?.delimitationLevelID,
			delimitationID: event?.node?.data?.id,
			voterRegisterID: event?.voterRegisterID
		};
		setisLoading(true);
		registerManagementReportService
			.getDistricts(payload)
			.then((response) => {
				setisLoading(false);
				const formattedNodes = response.map((district) => ({
					key: district.id,
					data: {
						id: district?.id,
						voterRollStatusID: district?.voterRollStatusID,
						name: district?.name,
						code: district.code,
						type: district?.type,
						delimitationID: district?.id,
						delimitationLevelID: district?.delimitationLevelID,
						eventTypeID: event?.eventTypeID,
						eventID: event?.eventID,
						eventName: event?.name,
						description: event?.description,
						isActive: event?.isActive,
						eventType: event?.eventType,
						eventCategoryID: event?.eventCategoryID,
						categoryName: event?.categoryName,
						level: 1,
						levelName: changeLang.get("national_delimitation.level1District")
					},
					leaf: false
				}));
				setNodes(formattedNodes);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching districts:", err);
			});
	};

	function OnTreeExpand(data) {
		if (voterRegisterType?.isNationalDelimitation) {
			NationalDelimitationMain(data);
		} else if (!voterRegisterType?.isNationalDelimitation) {
			LocalDelimitationMain(data);
		}
	}

	function NationalDelimitationMain(event) {
		const level = event?.node?.data?.level;
		switch (level) {
			case 1: // District
				GetNationalConstituencyByDistrictIdAsync(event);
				break;
			case 2: // Constituency
				GetVotingDistrictByConstituency(event);
				break;
			case 3: // Voting District
				GetVotingStationByVotingDistrictID(event);
				break;
			case 4: // Voting Centre
				GetVotingStationByVotingDistrictID(event);
				break;
			default:
				console.log("Level not handled:", level);
		}
	}

	function LocalDelimitationMain(event) {
		const level = event?.node?.data?.level;
		switch (level) {
			case 1: // Councils
				GetLocalCouncilsByDistrictIdAsync(event);
				break;
			case 2: // Voting District
				GetLocalVotingDistrictByConstituencID(event);
				break;
			case 3: // Voting District
				GetLocalVotingStationByVotingDistrictID(event);
				break;
			case 4: // Voting District
				GetPollingStaionByLocalVotingStation(event);
				break;
			default:
				console.log("Level not handled:", level);
		}
	}

	function GetLocalDistricts(event) {
		setisLoading(true);
		registerManagementReportService
			.getLocalDistricts({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: event?.voterRegisterID
			})
			.then((response) => {
				var districts = [];
				setisLoading(false);
				const formattedNodes = response.map((district) => ({
					key: district.id,
					data: {
						id: district?.id,
						voterRollStatusID: district?.voterRollStatusID,
						name: district?.name,
						code: district.code,
						type: district?.type,
						eventDelimitationId: district?.id,
						delimitationLevelID: district?.delimitationLevelID,
						eventTypeID: event?.eventTypeID,
						eventID: event?.eventID,
						eventName: event?.name,
						description: event?.description,
						isActive: event?.isActive,
						eventType: event?.eventType,
						eventCategoryID: district?.eventCategoryID,
						categoryName: district?.categoryName,
						level: 1,
						levelName: changeLang.get("national_delimitation.level1District")
					},
					leaf: false
				}));
				setNodes(formattedNodes);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching districts:", err);
			});
	}
	function GetLocalCouncilsByDistrictIdAsync(event) {
		setisLoading(true);
		registerManagementReportService
			.getCouncilsByDistrict({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: voterRegisterType?.voterRegisterID
			})
			.then((response) => {
				setisLoading(false);

				const councils = response.map((e) => ({
					key: `${event.node.key}-${e.id}`,
					data: {
						parentNodeId: event.node.data.eventID,
						eventDelimitationId: e?.id,
						id: e?.id,
						voterRollStatusID: e?.voterRollStatusID,
						delimitationLevelID: e?.delimitationLevelID,
						eventTypeID: event.node.data.eventTypeID,
						eventID: event.node.data.eventID,
						eventName: event.node.data.name,
						name: `${e?.code} - ${e.name}`,
						description: e.description,
						isActive: e.isActive,
						eventType: event.node.data.eventType,
						eventCategoryID: event.node.data.eventCategoryID,
						categoryName: event.node.data.categoryName,
						parentEventID: event.node.data.parentEventID,
						level: 2,
						levelName: changeLang.get("local_delimitation.level2ConstituencyCouncil")
					},
					leaf: false
				}));

				// Recursively update the matching node and insert children
				const updateTree = (nodes) => {
					return nodes.map((node) => {
						if (node.key === event.node.key) {
							return {
								...node,
								children: councils
							};
						} else if (node.children) {
							return {
								...node,
								children: updateTree(node.children)
							};
						}
						return node;
					});
				};

				const updatedTree = updateTree(nodes);
				setNodes(updatedTree);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Failed to fetch councils:", err);
			});
	}
	function GetLocalVotingDistrictByConstituencID(event) {
		setisLoading(true);
		registerManagementReportService
			.GetLocalVotingDistrictsByCouncilIdAsync({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: voterRegisterType?.voterRegisterID
			})
			.then((response) => {
				setisLoading(false);

				const votingDistricts = response.map((e) => ({
					key: `${event.node.key}-${e.id}`,
					data: {
						parentNodeId: event.node.data.eventID,
						voterRollStatusID: e?.voterRollStatusID,
						eventDelimitationId: e.id,
						eventDelimitationLevelId: 3,
						delimitationLevelID: 3,
						id: e?.id,
						eventTypeID: event.node.data.eventTypeID,
						eventID: event.node.data.eventID,
						eventName: event.node.data.name,
						name: `${e?.code} - ${e.name}`,
						description: e.description,
						isActive: e.isActive,
						eventType: event.node.data.eventType,
						eventCategoryID: event.node.data.eventCategoryID,
						categoryName: event.node.data.categoryName,
						parentEventID: event.node.data.parentEventID,
						level: 3,
						levelName: changeLang.get("local_delimitation.level3PollingElectorDivision")
					},
					leaf: false
				}));

				// Recursively update tree and attach voting districts under the correct council node
				const updateTree = (tree) => {
					return tree.map((node) => {
						if (node.key === event.node.key) {
							return {
								...node,
								children: votingDistricts
							};
						} else if (node.children) {
							return {
								...node,
								children: updateTree(node.children)
							};
						}
						return node;
					});
				};

				const updatedTree = updateTree(nodes);
				setNodes(updatedTree);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching local voting districts:", err);
			});
	}
	function GetPollingStaionByLocalVotingStation(event) {
		setisLoading(true);
		registerManagementReportService
			.getPollingStaionByLocalVotingStation({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: voterRegisterType?.voterRegisterID
			})
			.then((response) => {
				setisLoading(false);
				const pollingStations = response.map((e) => ({
					key: `${event.node.key}-${e.id}`,
					data: {
						parentNodeId: event.node.data.eventID,
						voterRollStatusID: e?.voterRollStatusID,
						delimitationID: e?.delimitationID,
						delimitationLevelID: e?.delimitationLevelID,
						eventTypeID: event.node.data.eventTypeID,
						eventID: event.node.data.eventID,
						eventName: event.node.data.name,
						name: `${e?.code} - ${e.name}`,
						id: e?.id,
						description: e.description,
						isActive: e.isActive,
						eventType: event.node.data.eventType,
						eventCategoryID: event.node.data.eventCategoryID,
						categoryName: event.node.data.categoryName,
						parentEventID: event.node.data.parentEventID,
						level: 6,
						levelName: changeLang.get("local_delimitation.level6PollingStation")
					},
					leaf: false
				}));

				// Recursively attach children to the matching node
				const updateTree = (tree) => {
					return tree.map((node) => {
						if (node.key === event.node.key) {
							return {
								...node,
								children: pollingStations
							};
						} else if (node.children) {
							return {
								...node,
								children: updateTree(node.children)
							};
						}
						return node;
					});
				};

				const updatedTree = updateTree(nodes);
				setNodes(updatedTree);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching polling stations:", err);
			});
	}

	function GetNationalConstituencyByDistrictIdAsync(event) {
		setisLoading(true);

		registerManagementReportService
			.getConstituenciesByDistrict({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: voterRegisterType?.voterRegisterID
			})
			.then((response) => {
				setisLoading(false);
				const constituencies = response.map((e) => ({
					key: `${event.node.key}-${e.id}`,
					data: {
						parentNodeId: event.node.data.eventID,
						id: e?.id,
						delimitationLevelID: e?.delimitationLevelID,
						voterRollStatusID: e?.voterRollStatusID,
						eventTypeID: e?.eventTypeID,
						eventID: e?.eventID,
						eventName: e?.name,
						name: e?.code + " - " + e.name,
						description: e?.description,
						isActive: e?.isActive,
						eventType: e?.eventType,
						eventCategoryID: e?.eventCategoryID,
						categoryName: e?.categoryName,
						parentEventID: e?.parentEventID,
						level: 2,
						levelName: changeLang.get("national_delimitation.level2ConstituencyCouncil")
					},
					leaf: false
				}));

				const updateTree = (nodes) => {
					return nodes.map((node) => {
						if (node.key === event.node.key) {
							return {
								...node,
								children: constituencies
							};
						} else if (node.children) {
							return {
								...node,
								children: updateTree(node.children)
							};
						}
						return node;
					});
				};

				const updatedTree = updateTree(nodes);
				setNodes(updatedTree);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching constituencies:", err);
			});
	}

	function GetVotingDistrictByConstituency(event) {
		setisLoading(true);
		try {
			registerManagementReportService
				.getPollingDivisionsByConstituency({
					delimitationLevelID: event?.node?.data?.delimitationLevelID,
					delimitationID: event?.node?.data?.id,
					voterRegisterID: voterRegisterType?.voterRegisterID
				})
				.then((response) => {
					setisLoading(false);
					const votingDistricts = response.map((e) => ({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							id: e?.id,
							delimitationLevelID: e?.delimitationLevelID,
							voterRollStatusID: e?.voterRollStatusID,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code + " - " + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 3,
							levelName: changeLang.get("national_delimitation.level3PollingElectorDivision")
						},
						leaf: false
					}));

					// Recursively update the matching node and insert children
					const updateTree = (nodes) => {
						return nodes.map((node) => {
							if (node.key === event.node.key) {
								return {
									...node,
									children: votingDistricts
								};
							} else if (node.children) {
								return {
									...node,
									children: updateTree(node.children)
								};
							}
							return node;
						});
					};

					const updatedNodes = updateTree(nodes);
					setNodes(updatedNodes);
				})
				.catch((err) => {
					setisLoading(false);
					console.error("Error fetching polling divisions:", err);
				});
		} catch (err) {
			setisLoading(false);
			console.error("Error fetching polling divisions:", err);
		}
	}

	function GetVotingStationByVotingDistrictID(event) {
		setisLoading(true);
		registerManagementReportService
			.getRegistrationCentresByPollingDivision({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: voterRegisterType?.voterRegisterID
			})
			.then((response) => {
				setisLoading(false);

				const votingStations = response.map((e) => ({
					key: `${event.node.key}-${e.id}`,
					data: {
						parentNodeId: event.node.data.eventID,
						id: e?.id,
						voterRollStatusID: e?.voterRollStatusID,
						delimitationLevelID: e?.delimitationLevelID,
						delimitationID: e?.pollingDivisionID,
						eventTypeID: event.node.data.eventTypeID,
						eventID: event.node.data.eventID,
						eventName: event.node.data.name,
						name: e?.code + " - " + e.name,
						description: e.description,
						isActive: e.isActive,
						eventType: event.node.data.eventType,
						eventCategoryID: event.node.data.eventCategoryID,
						categoryName: event.node.data.categoryName,
						parentEventID: event.node.data.parentEventID,
						level: 4,
						levelName: changeLang.get("national_delimitation.level4RegistrationCentre")
					},
					leaf: true
				}));

				const updateTree = (nodes) => {
					return nodes.map((node) => {
						if (node.key === event.node.key) {
							return {
								...node,
								children: votingStations
							};
						} else if (node.children) {
							return {
								...node,
								children: updateTree(node.children)
							};
						}
						return node;
					});
				};

				const updatedTree = updateTree(nodes);
				setNodes(updatedTree);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching voting stations:", err);
			});
	}
	function GetLocalVotingStationByVotingDistrictID(event) {
		setisLoading(true);
		registerManagementReportService
			.getLocalVotingStationsByVotingDistrictIDAsync({
				delimitationLevelID: event?.node?.data?.delimitationLevelID,
				delimitationID: event?.node?.data?.id,
				voterRegisterID: voterRegisterType?.voterRegisterID
			})
			.then((response) => {
				setisLoading(false);

				const votingStations = response.map((e) => ({
					key: `${event.node.key}-${e.id}`,
					data: {
						parentNodeId: event.node.data.eventID,
						id: e?.id,
						voterRollStatusID: e?.voterRollStatusID,
						delimitationLevelID: e?.delimitationLevelID,
						delimitationID: e?.pollingDivisionID,
						eventTypeID: event.node.data.eventTypeID,
						eventID: event.node.data.eventID,
						eventName: event.node.data.name,
						name: e?.code + " - " + e.name,
						description: e.description,
						isActive: e.isActive,
						eventType: event.node.data.eventType,
						eventCategoryID: event.node.data.eventCategoryID,
						categoryName: event.node.data.categoryName,
						parentEventID: event.node.data.parentEventID,
						level: 4,
						levelName: changeLang.get("local_delimitation.level4RegistrationCentre")
					},
					leaf: true
				}));

				const updateTree = (nodes) => {
					return nodes.map((node) => {
						if (node.key === event.node.key) {
							return {
								...node,
								children: votingStations
							};
						} else if (node.children) {
							return {
								...node,
								children: updateTree(node.children)
							};
						}
						return node;
					});
				};

				const updatedTree = updateTree(nodes);
				setNodes(updatedTree);
			})
			.catch((err) => {
				setisLoading(false);
				console.error("Error fetching voting stations:", err);
			});
	}

	const [nodes, setNodes] = useState([]);
	const [expandedKeys, setExpandedKeys] = useState({});
	const [selectedReportDelimitations, setselectedReportDelimitations] = useState([]);
	const [isSelected, setIsselected] = useState(false);

	const [mergeReportFiles, setmergeReportFiles] = useState(false);

	// Utility to recursively get all children
	const getAllChildNodes = (node) => {
		let children = [];
		if (node.children) {
			node.children.forEach((child) => {
				children.push(child);
				children = children.concat(getAllChildNodes(child));
			});
		}
		return children;
	};

	// Find the immediate parent node
	const findParentNode = (key, nodes, parent = null) => {
		for (let node of nodes) {
			if (node.key === key) return parent;
			if (node.children) {
				const found = findParentNode(key, node.children, node);
				if (found) return found;
			}
		}
		return null;
	};

	// Update parent selection based on child state
	const updateParentSelection = (nodeKey, nodes, updated, setSelected) => {
		const parent = findParentNode(nodeKey, nodes);
		if (!parent) return;

		const allChildrenSelected = parent.children.every((child) => updated.some((s) => s.key === child.key));

		const parentAlreadySelected = updated.some((s) => s.key === parent.key);

		if (allChildrenSelected && !parentAlreadySelected) {
			updated.push(parent);
		} else if (!allChildrenSelected && parentAlreadySelected) {
			updated = updated.filter((s) => s.key !== parent.key);
		}

		setSelected(updated);
		updateParentSelection(parent.key, nodes, updated, setSelected);
	};

	// Checkbox change for each row
	const onCheckboxChange = (isChecked, rowData) => {
		setselectedReportDelimitations((prevSelected) => {
			let updated = [...prevSelected];
			const allChildNodes = getAllChildNodes(rowData);

			if (isChecked) {
				updated.push(rowData, ...allChildNodes);
			} else {
				const allKeysToRemove = [rowData.key, ...allChildNodes.map((n) => n.key)];
				updated = updated.filter((item) => !allKeysToRemove.includes(item.key));
			}

			// Remove duplicates
			updated = updated.filter((v, i, a) => a.findIndex((t) => t.key === v.key) === i);

			updateParentSelection(rowData.key, nodes, updated, setselectedReportDelimitations);

			return updated;
		});
	};

	const handleSelectAll = (isChecked) => {
		if (isChecked) {
			const allNodes = flattenTree(nodes);
			setselectedReportDelimitations(allNodes);
		} else {
			setselectedReportDelimitations([]);
		}
	};

	const extractSelectedDelimitations = (selectedNodes, allNodes) => {
		const selectedKeys = selectedNodes.map((n) => n.key);
		const keyToNodeMap = {};
		const result = [];

		const mapKeys = (nodes) => {
			for (let node of nodes) {
				keyToNodeMap[node.key] = node;
				if (node.children) mapKeys(node.children);
			}
		};

		mapKeys(allNodes);

		const isAllChildrenSelected = (node) => {
			if (!node.children || node.children.length === 0) return false;
			return node.children.every((child) => selectedKeys.includes(child.key));
		};

		const visitedKeys = new Set();

		for (const node of selectedNodes) {
			if (visitedKeys.has(node.key)) continue;

			if (isAllChildrenSelected(node)) {
				result.push({
					delimitationId: node.data.id,
					delimitationLevelId: node.data.delimitationLevelID,
					voterRegisterID: voterRegisterType?.voterRegisterID
				});
				node.children.forEach((child) => visitedKeys.add(child.key)); // Skip individual children
			} else if (!node.children || node.children.length === 0 || !isAllChildrenSelected(node)) {
				result.push({
					delimitationId: node.data.id,
					delimitationLevelId: node.data.delimitationLevelID,
					voterRegisterID: voterRegisterType?.voterRegisterID
				});
			}

			visitedKeys.add(node.key);
		}

		return result;
	};

	const selectedDelimitationKeys = extractSelectedDelimitations(selectedReportDelimitations, nodes);

	const flattenTree = (nodes) => {
		let result = [];

		nodes.forEach((node) => {
			result.push(node);
			if (node.children && node.children.length > 0) {
				result = result.concat(flattenTree(node.children));
			}
		});

		return result;
	};

	const countAllNodes = (nodes) => flattenTree(nodes).length;

	//Updated treetable implementation

	const handlePublish = (data) => {
		setisLoading(true);
		const payload = {
			DelimitationLevelID: data?.delimitationLevelID,
			DelimitationID: data?.id,
			voterRegisterID: voterRegisterType?.voterRegisterID
		};
		registerManagementReportService
			.publishEventRegister(payload)
			.then((res) => {
				setisLoading(false);
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				return toast.show({
					severity: "error",
					summary: "Message",
					detail: err?.message,
					life: 2000
				});
			});
	};

	const handlePreview = (data) => {
		const payload = {
			mergeFiles: true,
			demarcationList: [
				{
					DelimitationLevelID: data?.delimitationLevelID,
					DelimitationID: data?.id,
					voterRegisterID: voterRegisterType?.voterRegisterID
				}
			],
			voterRegisterID: voterRegisterType?.voterRegisterID
		};
		getRegisterReport(payload);
	};

	const [eventGroups, setEventGroups] = useState([{}]);
	const [selectedEventgroup, setSelectedEventgroup] = useState(null);
	const [eventsPergroup, seteventsPergroup] = useState(null);
	const [selectedeventsPergroup, setselectedeventsPergroup] = useState(null);
	useEffect(() => {
		GetAllEventGrops();
	}, []);

	async function GetAllEventGrops() {
		setisLoading(true);
		await eventService
			.getAllGroups()
			.then((data) => {
				setEventGroups(data);
				setselectedeventsPergroup(null);
				setisLoading(false);
			})
			.catch((err) => {
				setisLoading(false);
			});
	}
	async function GetAllEvents(eventGroup) {
		setisLoading(true);
		console.log(eventGroup);
		try {
			await eventService
				.getAllEvents({
					EventGroupID: eventGroup?.eventGroupID,
					ActiveOnly: true,
					IncludeByElection: true,
					PageIndex: 1,
					PageSize: 10000
				})
				.then((data) => {
					seteventsPergroup(data);
					setSelectedRegister(null);
					// setVoterRegisters(null);
					setisLoading(false);
				});
			setisLoading(false);
		} catch (err) {
			console.error("Error fetching events:", err);
			setisLoading(false);
		}
	}
	const [selectedNodeKeys, setSelectedNodeKeys] = useState({});

	console.log(selectedNodeKeys);
	return (
		<div className="card  p-align-stretch vertical-container">
			<ScreenLoader visible={isLoading || fetchReportLoader} />
			<PrintOut setBase64={setBase64} base64={base64} showDialog={showReport} setShowDialog={setshowReport} />
			<div className="card grid">
				<div className="lg:col-6 col-12 ">
					<label>Register Type</label>
					<DropDown
						filter
						style={{ width: "100%" }}
						optionLabel="name"
						value={registerType ? registerType : "Select Register Type"}
						onChange={(e) => {
							setRegisterType(e.value);
							setAddRegisterForm((form) => ({ ...form, registerTypeID: e.value.id }));
							setSelectedEventgroup(null);
							seteventsPergroup(null);
							setVoterRegisterType(null);

							setVoterRegisters([]);
							//  GetAllEventRegisters({
							// 	registerTypeID: e.value?.id,
							// 	eventID: selectedeventsPergroup?.eventID,
							// 	eventGroupID: selectedEventgroup?.eventGroupID
							//  });
						}}
						options={lookups?.registerTypes}
					/>
				</div>
				{registerType && registerType?.id == 1 && (
					<>
						<div className="lg:col-6 col-12 ">
							<label>Event Group</label>
							<DropDown
								filter
								style={{ width: "100%" }}
								optionLabel="name"
								value={selectedEventgroup ? selectedEventgroup : "Select Event Group"}
								onChange={(e) => {
									const selected = e.value;
									setSelectedEventgroup(selected);
									setselectedeventsPergroup(null);
									GetAllEvents(selected);
									setVoterRegisters([]);
									// GetAllEventRegisters({
									// 	registerTypeID: registerType?.id,
									// 	eventID: selectedeventsPergroup?.eventID,
									// 	eventGroupID: e.value?.eventGroupID
									// });
								}}
								options={eventGroups}
							/>
						</div>
						<div className="lg:col-6 col-12">
							<label>Event Name</label>
							<DropDown
								filter
								style={{ width: "100%" }}
								optionLabel="name"
								value={selectedeventsPergroup?.name ? selectedeventsPergroup?.name : " Select Event"}
								onChange={(e) => {
									setselectedeventsPergroup(e?.value);
									setVoterRegisterType(null);
									GetAllEventRegisters({
										registerTypeID: registerType?.id,
										eventID: e?.value?.eventID,
										eventGroupID: selectedEventgroup?.eventGroupID
									});
									//fetchDistrictsForRegister(e.value);
									// this should also update setNodes([...])
								}}
								options={eventsPergroup}
							/>
						</div>
					</>
				)}
				<div className="lg:col-6 col-12 ">
					<label>Register</label>
					<DropDown
						filter
						style={{ width: "100%" }}
						optionLabel="name"
						value={voterRegisterType?.name ? voterRegisterType?.name : " Select a Register"}
						onChange={(e) => {
							setVoterRegisterType(e.value);
							fetchDistrictsForRegister(e.value);
							// this should also update setNodes([...])
						}}
						options={voterRegisters}
					/>
				</div>
				{registerType && (registerType.id == 2 || (registerType.id == 1 && selectedeventsPergroup)) && (
					<div className="col-12">
						<h6>Elector Registers</h6>
						{permission?.actions?.includes(permissionLookUp.Create) && (
							<Button
								className=" left-0 p-button-success mr-2"
								icon="pi pi-plus"
								label="Create Register"
								onClick={(e) => setShowAddRegisterForm(true)}
							/>
						)}
					</div>
				)}
			</div>

			<div className="card">
				<TabView>
					<TabPanel header="Register Details">
						<DataTable
							size="small"
							scrollable={true}
							value={voterRegisters}
							dataKey="id"
							paginator
							rows={5}
							rowsPerPageOptions={[5, 10, 25]}
							className="datatable-responsive "
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
							emptyMessage="No register found."
							responsiveLayout="scroll"
							resizableColumns
							columnResizeMode="expand"
							filterDisplay="name"
							globalFilterFields={["name"]}
							loading={isLoading}
						>
							<Column field="name" header="Name" sortable className=""></Column>
							<Column field="description" header="Description" sortable></Column>
							<Column field="voterRegisterType" header="Type" sortable></Column>
							<Column
								field="active"
								header="Status"
								body={(e) => {
									if (e.voterRegisterTypeID === 2) {
										return e.certified ? (
											<Button
												label="Certified"
												style={{ textAlign: "center", height: "30px" }}
												className="p-button-success p-button-rounded"
											/>
										) : (
											<Button
												label="Not Certified"
												style={{ textAlign: "center", height: "30px" }}
												className="p-button-danger p-button-rounded"
											/>
										);
									}
									if (e.voterRegisterTypeID === 1) {
										return e.certified ? (
											<Button
												label="Released"
												style={{ textAlign: "center", height: "30px" }}
												className="p-button-success p-button-rounded"
											/>
										) : (
											<Button
												label="Not Released"
												style={{ textAlign: "center", height: "30px" }}
												className="p-button-danger p-button-rounded"
											/>
										);
									}
								}}
							></Column>
							<Column
								field="processingStatus"
								header="Processing"
								body={(e) => {
									const statusMap = {
										0: { label: "Pending", className: "p-button-secondary" }, // Gray
										1: { label: "Processing", className: "p-button-warning" }, // Yellow
										2: { label: "Done", className: "p-button-success" }, // Green
										3: { label: "Done (Errors)", className: "p-button-danger" } // Red
									};

									const { label, className } = statusMap[e.processingStatus] || {
										label: "Unknown",
										className: "p-button-secondary"
									};

									return (
										<Button
											label={label}
											className={`${className} p-button-rounded`}
											style={{ textAlign: "center", height: "30px" }}
										/>
									);
								}}
							/>
							<Column
								field="actions"
								header="Actions"
								body={(e) => (
									<>
										{permission?.actions?.includes(permissionLookUp.Update) && (
											<Button
												disabled={parseInt(e.status) == 0}
												style={{ textAlign: "center", width: "30px", height: "30px" }}
												icon={"pi pi-pencil"}
												className="p-button-primary p-button-rounded mr-2 "
												tooltip="Click to Edit"
												onClick={(a) => {
													setshowEditRegister(true);
													setSelectedRegister(e);
													handleEditRegister();
												}}
											/>
										)}
										{/* {permission?.actions?.includes(permissionLookUp.Update) && ( */}
										<Button
											disabled={e?.certified}
											style={{ textAlign: "center", width: "30px", height: "30px" }}
											icon={"pi pi-file-edit"}
											className="p-button-success p-button-rounded mr-2 "
											tooltip="Click to Certify"
											onClick={() => handleRegisterClick(e)}
										/>
										<Button
											style={{ textAlign: "center", width: "30px", height: "30px" }}
											icon={"pi pi-print"}
											className="p-button-info p-button-rounded mr-2 "
											tooltip="Click to Print"
											onClick={() => handleDownloadReport(e)}
										/>
										{/* )} */}
									</>
								)}
							></Column>
						</DataTable>
					</TabPanel>

					{voterRegisterType && (
						<TabPanel header={voterRegisterType?.name}>
							<div className="grid"></div>
							<TreeTable
								value={nodes}
								expandedKeys={expandedKeys}
								emptyMessage="No data found."
								onToggle={(e) => setExpandedKeys(e.value)}
								onExpand={(e) => OnTreeExpand(e)}
								style={{ marginTop: "5px" }}
								footer={
									<div className="grid justify-end">
										<div className="hidden lg:col-6"></div>
										<div className="col-12  lg:col-2 flex">
											<Checkbox
												disabled={selectedDelimitationKeys.length <= 0}
												onChange={(e) => setmergeReportFiles(!mergeReportFiles)}
												checked={mergeReportFiles}
											>
												Merge Files
											</Checkbox>
											<label className="ml-2">Merge Files</label>
										</div>
										<div className="col-12  lg:col-4">
											<Button
												type="button"
												style={{ width: "100%" }}
												severity="success"
												icon="pi pi-download"
												label="Download"
												tooltip="Print Selected Delimitations"
												onClick={() => {
													delimitationReport(selectedDelimitationKeys);
												}}
												disabled={selectedDelimitationKeys.length <= 0}
											/>
										</div>
									</div>
								}
								tableStyle={{ minWidth: "50rem" }}
								resizableColumns
								scrollable
								dataKey="key"
								paginator
								rows={5}
								rowsPerPageOptions={[5, 10, 25]}
								currentPageReportTemplate="Showing {first} to {last} of {totalRecords} events"
								columnResizeMode="expand"
								filterDisplay="menu"
							>
								<Column
									style={{ width: "50px" }}
									header={
										<Checkbox
											inputId="selectAll"
											checked={nodes.length > 0 && selectedReportDelimitations.length === countAllNodes(nodes)}
											onChange={(e) => handleSelectAll(e.checked)}
										/>
									}
									body={(rowData) => (
										<Checkbox
											inputId={rowData.key}
											checked={selectedReportDelimitations.some((item) => item.key === rowData.key)}
											onChange={(e) => onCheckboxChange(e.checked, rowData)}
										/>
									)}
								/>
								<Column field="name" header="District Name" style={{ width: "250px" }} expander />
								<Column field="levelName" header="Level"></Column>
								<Column
									style={{ width: "200px" }}
									field="isActive"
									header="Status"
									body={(e) => {
										return (
											<Button
												label={(() => {
													const statusID = parseInt(e.data?.voterRollStatusID);
													switch (statusID) {
														case 1:
															return "All Files Available";
														case 2:
															return "Some Files Available";
														case 3:
															return "No Files Available";
														case 4:
															return "No Voters";
														default:
															return "Unknown";
													}
												})()}
												style={{ height: "30px" }}
												className={`p-button-rounded ${
													e.data?.voterRollStatusID === 1
														? "p-button-success"
														: e.data?.voterRollStatusID === 2
															? "p-button-warning"
															: e.data?.voterRollStatusID === 3
																? "p-button-secondary"
																: e.data?.voterRollStatusID === 4
																	? "p-button-info"
																	: "p-button-secondary"
												}`}
											/>
										);
									}}
								/>{" "}
								<Column
									style={{ width: "250px" }}
									body={(rowData) => {
										return (
											<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
												<Button
													className="p-button-danger"
													type="button"
													icon="pi pi-file-export"
													rounded
													onClick={() => handlePublish(rowData?.data)}
												/>
												<Button
													className="p-button-info"
													type="button"
													severity="info"
													rounded
													icon="pi pi-eye"
													onClick={() => {
														handlePreview(rowData?.data);
													}}
													tooltip="Click to Preview"
												/>
											</div>
										);
									}}
									header="Actions"
								/>
							</TreeTable>
						</TabPanel>
					)}
				</TabView>
			</div>

			{showCertifyRegisterForm && (
				<Dialog
					draggable={false}
					header={
						<>
							<span>Certify Register</span>
						</>
					}
					visible={showCertifyRegisterForm}
					style={{ width: "95%", height: "100%" }}
					modal
					onHide={() => {
						setShowCertifyRegisterForm(false);
						setSelectedRegister(null);
						setsignatureData(null);
					}}
					footer={
						<>
							<Button className="p-button-success" type="button" label="Certify" onClick={() => handleCertify()} />

							<Button
								className="p-button-danger"
								type="button"
								label="Close"
								onClick={() => {
									setShowCertifyRegisterForm(false);
									setsignatureData(null);
								}}
							/>
						</>
					}
				>
					<Divider>
						<h5 className="mt-2">
							Certify the voters {selectedRegister?.voterRegisterType} for {selectedRegister?.name}
						</h5>
					</Divider>
					{selectedRegister?.voterRegisterType === "Final Register" && (
						<div style={{ alignItems: "center" }}>
							<AddSignature
								setSignatureForm={setSignatureForm}
								signatureForm={signatureForm}
								uploaded={uploaded}
								setUploaded={setUploaded}
								signatureData={signatureData}
								setsignatureData={setsignatureData}
								ReloadVoterRegister={GetAllEventRegisters}
							/>
						</div>
					)}
				</Dialog>
			)}
			<Dialog
				draggable={true}
				header={
					<>
						<li className="pi pi-eye"> </li>
						<span> New Register</span>
					</>
				}
				visible={showAddRegisterForm}
				style={{ width: "50%", height: "50%" }}
				modal
				onHide={(e) => {
					setShowAddRegisterForm(false);
					setAddRegisterForm(null);
				}}
				footer={
					<Button
						className="p-button-danger"
						type="button"
						label="Close"
						onClick={() => {
							setShowAddRegisterForm(false);
							setAddRegisterForm(null);
						}}

					/>
				}
			>

				<AddEventRegister
					registerType={registerType}
					events={eventsPergroup}
					form={addRegisterForm}
					setForm={setAddRegisterForm}
					show={showAddRegisterForm}
					setShow={setShowAddRegisterForm}
					onSubmit={AddNewRegister}
					setfetchReportLoader={setfetchReportLoader}
					fetchReportLoader={fetchReportLoader}
					selectedeventsPergroup={selectedeventsPergroup}
				/>
			</Dialog>
			{showEditRegister && (
				<Dialog
					draggable={true}
					header={
						<>
							<li className="pi pi-eye mr-1"> </li>
							<span> Edit Register</span>
						</>
					}
					visible={showEditRegister}
					style={{ width: "50%", height: "50%" }}
					modal
					onHide={(e) => {
						setshowEditRegister(false);
					}}
					footer={<Button className="p-button-danger" type="button" label="Close" onClick={() => setshowEditRegister(false)} />}
				>
					<EditRegister
						showEditRegister={showEditRegister}
						setshowEditRegister={setshowEditRegister}
						selectedRegister={selectedRegister}
						setSelectedRegister={selectedRegister}
						RefreshVoterRegister={GetAllEventRegisters}
					/>
				</Dialog>
			)}
		</div>
	);
};
